import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";

import { SxProps, ButtonProps } from "@mui/material";

type CustomButtonProps = ButtonProps & {
  title: string;
  loading?: boolean;
  sxProps?: SxProps | undefined;
  backgroundColor?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

export const CustomPrimaryButton: React.FC<CustomButtonProps> = ({
  title,
  loading,
  sxProps,
  ...props
}: CustomButtonProps) => {


  return (
    <>
      <LoadingButton
        fullWidth
        variant="contained"
        color="primary"
        type="submit"
        loading={loading}
        sx={[
          {
            boxShadow: "0 0 0 0",
            height: "44px",
            bgcolor: "#000",
            borderRadius: "12px",
            textTransform: "none",
            fontSize: "14px",
            textAlign:"center",
            fontWeight: "400",
            "&:hover": {
              boxShadow: "0 0 0 0",
              bgcolor: "#222",
            },
          },
          ...(Array.isArray(sxProps) ? sxProps : [sxProps]),
        ]}
        {...props}
      >
        {title}
      </LoadingButton>
    </>
  );
};
